import ControlProcessControlDialogController from './control_dialog/control_dialog.controller';
import ControlProcessDocumentFLowDialogController from './documentFlowDialog/documentFlowController';
angular
  .module( 'VSPApp' )
  .controller('ControlProcessControlDialogController', ControlProcessControlDialogController)
  .controller('ControlProcessDocumentFLowDialogController', ControlProcessDocumentFLowDialogController)
;
